import './AI Doctor.css';
import Navbar from './Navbar.js';
import brain3 from './doctor-4.webp';
import PDF from './pdf.js';
import doctor from './doctor.png';
import Footer from './footer.js';
import video_brain from './1.mp4';
import React, { useRef } from 'react';
import VideoPlayer from "./Video_Player.js";



const AI_Doctor = () => {
  const videoRef = useRef(null);
  const lastTime = useRef(0);

  const handleTimeUpdate = () => {
    const video = videoRef.current;
    if (!video) return;
    if (Math.abs(video.currentTime - lastTime.current) > 1) {
      video.currentTime = lastTime.current;
    } else {
      lastTime.current = video.currentTime;
    }
  };
  return (  
    <div className="AI_Doctor-page">
       <Navbar />
        <h1 className='main_heading'>Cnyda Dynamics Product Division</h1>
      <header className="AI_Doctor-hero">
        <div className="AI_Doctor-content">
          <h1>AI Doctor avatar:</h1>
          <p>
            We are developing an innovative 'Doctor AI avatar' by harnessing our cutting-edge research on human brain and cognition to address one of the most pressing healthcare challenges of our time. This AI Doctor avatar will be trained across 18 specialties and will be compared to expert doctors in its training phase; this platform will enable nursing staff and primary physicians to tap into the collective expertise of all specialists in one comprehensive resource, 
            fostering significant synergies during physical examinations, diagnoses, and treatments for patients..
          </p>
          <video 
            src={video_brain} 
            className="image_AI_Doctor" 
            autoPlay 
            loop 
            muted 
            playsInline
          />
        
        </div>

      <div className='pdf-paper'>
       <h1>AI Doctor Foundation Paper</h1>
        </div>
        <PDF 
        title="White Paper" 
        file="/Medical Paper_v3.pdf" 
      />
      
      <div className="video-header">
      <h1>AI Doctor Live Demo</h1>
      </div>
      <VideoPlayer src="/AI_doctor_video.mp4" />
      </header> 
      <Footer/>
    </div>
    
  );
};

export default AI_Doctor;